import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../api/helpers/request";
import Project from "../../api/types/Project";

const fetchProject = createAsyncThunk(
    'fetchProject',
    async (projectId: string) => {
        return await request<Project>('GET', `/api/projects/${projectId}`);
    }
);

export default fetchProject;